/** Shared canvas setup — fills the shell, not a postage-stamp box. */
export function mountGameCanvas(
  canvas: HTMLCanvasElement,
  opts: { maxH?: number; maxW?: number; minH?: number; minW?: number } = {}
): {
  ctx: CanvasRenderingContext2D
  size: () => { w: number; h: number }
  dispose: () => void
} {
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('2d context unavailable')

  const maxW = opts.maxW ?? 1600
  const maxH = opts.maxH ?? 960
  const minW = opts.minW ?? 320
  const minH = opts.minH ?? 360

  let w = 0
  let h = 0
  const resize = () => {
    const parent = canvas.parentElement
    const rawW = parent?.clientWidth || Math.min(maxW, window.innerWidth - 32)
    const rawH =
      parent?.clientHeight && parent.clientHeight > 40
        ? parent.clientHeight
        : Math.min(maxH, Math.floor(window.innerHeight * 0.82))
    w = Math.max(minW, Math.min(maxW, rawW))
    h = Math.max(minH, Math.min(maxH, rawH))
    canvas.width = w * devicePixelRatio
    canvas.height = h * devicePixelRatio
    canvas.style.width = `${w}px`
    canvas.style.height = `${h}px`
    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0)
  }
  resize()
  requestAnimationFrame(resize)
  window.addEventListener('resize', resize)

  return {
    ctx,
    size: () => ({ w, h }),
    dispose: () => window.removeEventListener('resize', resize)
  }
}
